import styles from './ToggleButton.module.css'
import classNames from 'classnames'

interface ToggleButtonProps{
    caption: string,
    value: any,
    active?: boolean,
    onClick: (event: any) => void
}



export const ToggleButton = (props: ToggleButtonProps) => {
    const {
        active = false,
        caption,
        value,
        onClick
    } = props

    const handleToggleButtonClick = () => {
        onClick?.(value)
    }

    const toggleButtonClasses = classNames(styles.ToggleButton, {
        [styles[`ToggleButton--Active`]]: active
    })

    return (
        <button 
            className={toggleButtonClasses}
            onClick={handleToggleButtonClick}>
            <span className={styles.ToggleButton__Caption}>{caption}</span>
        </button>
    )
}